import { StarRating } from '@workwhile/ui'
import { WorkerActions } from 'components/WorkerActions'
import { shouldShowApproveButton } from 'lib/work'
import { AssignedWorkerOptionsEnum } from 'lib/work/assigned_work_options'
import { useShiftDetail } from 'pages/ShiftDetailPage/useShiftDetail'
import { Work } from 'typings/common_defs'
import { Flex, Text } from 'ui'
import { useAssignedWorkRow } from '../useAssignedWorkerRow'

interface Props {
  work: Work
}

export const AssignedWorkerRating = ({ work }: Props) => {
  const { shift } = useShiftDetail()
  const { data, setValue } = useAssignedWorkRow(work.id)
  const worker = work.worker

  if (!shift) return null

  if (!shouldShowApproveButton(data)) {
    return null
  }

  if (data?.finishedEarlyCategory === AssignedWorkerOptionsEnum.NO_SHOW) {
    return (
      <Flex flexDirection="row" alignItems="center" mr={3}>
        <Text color="errors.200">Will Be Blocked</Text>
      </Flex>
    )
  }

  if (!worker) return null

  return (
    <Flex flexDirection="row" alignItems="center" mr={1} gap={4}>
      <StarRating
        maxNumStars={5}
        selected={data.e2wReview?.rating}
        selectedChangedCallback={(value) => setValue('e2wReview.rating', value)}
      />

      <WorkerActions
        worker={{
          id: worker.id,
          name: worker.name,
          profilePicUrl: worker.profilePicUrl,
          favorites: worker.favorites || 0,
          rating: worker.rating || 0,
          numShiftsForCompany: worker.numShiftsForCompany || 0,
          firstActive: worker.firstActive || '',
          numFinishedShifts: worker.numFinishedShifts || 0,
          statusForCompany: worker.statusForCompany || null,
          positionTemplateBlocks: worker.positionTemplateBlocks || [],
          rosters: worker.rosters || [],
        }}
        slim
      />
    </Flex>
  )
}
